<template>
  <div>
    <v-dialog v-model="localModal" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark tabs>
          <v-toolbar-title>
            {{ getName(tournament ? tournament.name : '') }}
          </v-toolbar-title>
          <template #extension>
            <v-tabs
              v-model="tab"
              color="primary"
              dark
              centered
              slider-color="white"
            >
              <v-tab v-for="title in tabTitle" :key="title" ripple>
                {{ title }}
              </v-tab>
            </v-tabs>
          </template>
          <v-spacer />
          <v-toolbar-items>
            <!-- <v-btn
              v-if="can('delete', 'tournament',tournament )"
              icon
              dark
              @click="ifDelete(tournament._id)"
            >
              <v-icon>delete</v-icon>
            </v-btn> -->
            <v-btn
              icon
              dark
              :loading="$store.state.tournaments.loading"
              @click="$store.dispatch('tournaments/fetchOne', tournament._id)"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn dark icon @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-information :tournament="tournament" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-group-ranking :tournament="tournament" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-group-matches :tournament="tournament" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-clasification />
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <!-- <tab-videos v-if="tab == 4" :matches="listMatches"/> -->
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" small @click="$emit('close')">
            {{ $t('action.buttons.cancel') }}
          </v-btn>
          <v-btn
            v-if="tab === 0 && can('edit', 'tournament', tournament)"
            color="secondary"
            small
            @click="$emit('edit')"
          >
            {{ $t('action.buttons.edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete()"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TabClasification from './view/TabClasification'
import TabGroupMatches from './view/TabGroupMatches'
import TabGroupRanking from './view/TabGroupRanking'
import TabInformation from './view/TabInformation'
// import TabVideos from './view/TabVideos'
// import TabCourses from './view/TabCourses'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
export default {
  name: 'TournamentView',
  components: {
    // TabVideos,
    TabGroupMatches,
    TabGroupRanking,
    TabClasification,
    TabInformation,
    // TabCourses
    DialogDelete,
  },
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      tabTitle: [
        this.$t('titles.global.information'),
        this.$tc('models.group', 2),
        this.$tc('models.match', 2),
        this.$t('titles.tournaments.clasification'),
        // this.$t('titles.tournaments.videos')
      ],
      dialogDelete: false,
    }
  },
  mounted() {
    // if (this.tournament.stadiumId) {
    //   this.initAulas(this.tournament.stadiumId)
    // }
  },

  methods: {
    ...mapActions({
      setDelete: 'tournaments/delete',
    }),
    ifDelete() {
      this.dialogDelete = true
    },
    _setDelete() {
      this.setDelete(this.tournament._id)
        .then(() => {
          this.localModal = false
        })
        .finally(() => {
          this.dialogDelete = false
        })
    },
  },
  computed: {
    ...mapState({
      tournament: (state) => state.tournaments.selected,
      loading: (state) => state.tournaments.loading,
    }),
    listMatches() {
      let result = []
      // if (this.tournament.phases) {
      //   this.tournament.phases.forEach(itemPhase => {
      //     itemPhase.groups.forEach(itemGroup => {
      //       itemGroup.matches.forEach(item => result.push(item))
      //     })
      //   })
      // }
      return result
    },
    localModal: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) this.$emit('close')
      },
    },
  },
}
</script>
